<template>
  <div
    class="brands-icons-container w-100 d-flex align-items-center"
    :class="{ inline: inlineDesktop }"
  >
    <div v-for="(brand, index) in brands" :key="index" class="box-icon" :style="imgPadding">
      <component
        :is="brand.url ? (brand.blank ? 'a' : 'nuxt-link') : 'div'"
        :key="index"
        :to="brand.url"
        :href="brand.url"
        :target="!brand.blank ? '_self' : '_blank'"
      >
        <img
          :src="brand.src"
          :alt="brand.alt"
          :width="brand.scaledWidth || 93"
          :height="brand.scaledHeight || 43"
          :style="styles"
          loading="lazy"
        />
        <p v-if="brand.text" :style="{ color: textColor }" class="brand-text">
          {{ brand.text }}
        </p>
      </component>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandsBlock',
  props: {
    brands: {
      type: Array,
      required: true
    },
    height: {
      type: Number,
      required: false,
      default: 0
    },
    padding: {
      type: Number,
      required: false,
      default: 25
    },
    inlineDesktop: {
      type: Boolean,
      required: false,
      default: false
    },
    textColor: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    styles() {
      return this.height ? `height: ${this.height}px; width: auto;` : '';
    },
    imgPadding() {
      return `padding: ${this.padding}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
.brands-icons-container {
  flex-flow: wrap;
  justify-content: space-between;
  &.inline {
    @include min-lg {
      flex-flow: nowrap;
    }
  }
  .box-icon {
    margin: auto;
    display: flex;
    flex-direction: column;
    text-align: center;
    img {
      max-width: 150px;
      max-height: 80px;
      filter: brightness(1);
      height: auto;
      width: auto;
      margin: auto;
      max-width: 100%;
    }
    .brand-text {
      font-size: 14px;
      margin-top: 7px;
    }
  }
}
</style>
